export default {"src":"/_next/static/media/product-review.7b222308.svg","height":500,"width":750};